import * as yup from 'yup';

import i18n from '../../../app/i18n';
import { SUBJECT_LIMIT, EMAIL, SMS, BOTH, REVIEW } from './constants';
import { sanitizedEmailBody, sanitizedSmsBody } from './emailSanitizer';

export { sanitizedEmailBody, sanitizedSmsBody };

export const broadcastSchema = yup.object().shape({
  broadcastType: yup
    .mixed()
    .oneOf(
      ['sms', 'email', 'both'],
      i18n.t('broadcasts:validation.broadcastType'),
    ),
  subject: yup
    .string()
    .max(SUBJECT_LIMIT, i18n.t('broadcasts:validation.charLimit'))
    .when(['currentStep', 'broadcastType'], {
      is: (currentStep, broadcastType) =>
        currentStep === EMAIL ||
        (currentStep === REVIEW && [EMAIL, BOTH].includes(broadcastType)),
      then: yup
        .string()
        .required(
          i18n.t('broadcasts:validation.presence', { field: 'subject' }),
        ),
    }),
  emailBody: yup
    .string()
    .transform(value => sanitizedEmailBody(value))
    .when(['currentStep', 'broadcastType'], {
      is: (currentStep, broadcastType) =>
        currentStep === EMAIL ||
        (currentStep === REVIEW && [EMAIL, BOTH].includes(broadcastType)),
      then: yup
        .string()
        .required(
          i18n.t('broadcasts:validation.presence', { field: 'email body' }),
        ),
    }),
  smsBody: yup
    .string()
    .transform(value => sanitizedSmsBody(value))
    .when(['currentStep', 'broadcastType'], {
      is: (currentStep, broadcastType) =>
        currentStep === SMS ||
        (currentStep === REVIEW && [SMS, BOTH].includes(broadcastType)),
      then: yup
        .string()
        .required(
          i18n.t('broadcasts:validation.presence', { field: 'sms body' }),
        ),
    }),
});
